import { DeleteOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { ConfirmAction, } from 'components';
import { ToolMaintenance } from 'app/types/tool';
import { useDeleteToolMaintenanceMutation } from 'app/services/tools';
import { formatDate, formats } from 'utils/datetime';

const DeleteMaintenance = ({ maintenance }: { maintenance: ToolMaintenance }) => {
  const { t } = useTranslation();
  const [ deleteMaintenance, meta ] = useDeleteToolMaintenanceMutation();

  const handleRemoveClick = async (maintenance: ToolMaintenance) => {
    await deleteMaintenance(maintenance.Id).unwrap();
  };

  const label = `${formatDate(maintenance.CreatedAt, formats.DD_MM_YYYY_HH_mm)} ${t('entities.maintenance.title').toLowerCase()}`;

  return <ConfirmAction
    callback={() => handleRemoveClick(maintenance)}
    successMessage={t('common.deletesuccess', { content: label })}
    confirmMessage={t('common.deleteconfirm', { content: label })}
    meta={meta}
    tooltipButtonProps={{
      title: t('common.delete'),
      minimized: true,
      buttonProps: {
        danger: true,
        type: 'link',
        icon: <DeleteOutlined />,
      }
    }}
  />;


};

export default DeleteMaintenance;